import React, {Component} from 'react';
import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";
import PropTypes from "prop-types";
import {isNull} from 'lodash';
import AddModal from "./ApplicationSelect/AddModal";
import Tooltip from "../Tooltip";
import uuid from "react-native-uuid";
import {withTranslation} from "react-i18next";

class ApplicationSelect extends Component {

  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    this.state = {
      id: 'x' + uuid.v4(),
      searchTimeout: false,
      loading: false,
      search: '',
      searchNotFound: '',
      options: [],
      value: this.props.isMulti ? [] : null,
      modalAdd: false,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if(this.props.menuIsOpen){
      this.selectRef.current.focus();
    }

    if(!this.props.isMulti && this.props.value){
      this.setById(this.props.value);
    }
  }

  setById = (id) => {
    this.props.fetchById(id)
    .then(res => {
      this.setState({
        value: {
          value: this.props.value,
          label: this.getLabelSelected(res.data)
        }
      })
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.value !== this.props.value) {
      if(!this.props.isMulti) {
        if(this.props.value) {
          this.setById(this.props.value);
        } else {
          this.setState({ value: null });
        }
      } else {
        this.setState({ value: this.props.value || [] });
      }
    }
  }

  fetchData(search, callback){
    clearTimeout(this.state.searchTimeout);

    this.setState({
      searchTimeout: setTimeout(() => {
        this.props.searchData({
          page: 1,
          limit: 50,
          search,
        }, {
          sortField: this.props.sortField,
          sortOrder: this.props.sortOrder,
        })
        .then(res => {
          let options = res.data.map(entity => {
            return {
              value: entity.id,
              label: this.getLabel(entity),
            }
          });

          if(this.props.addNewOption && res.data.length === 0){
            options.push({
              value: null,
              label: this.props.addNewOption
            });
          }

          this.setState({
            data: res.data,
          }, () => {
            callback(options);
          });
        });
      }, 450)
    })
  }

  getLabel(entity){
    if(this.props.label){
      return this.props.label(entity);
    }

    return entity.name;
  }

  getLabelSelected(entity){
    if(this.props.labelSelected){
      return this.props.labelSelected(entity);
    }

    return entity.name;
  }

  handleInputChange(search){
    this.setState({ search });
    return search;
  }

  render() {
    const {id, value, data, modalAdd} = this.state;
    const {menuIsOpen, isMulti} = this.props;

    let selectProps = {
      id,
      classNamePrefix: "react-select",
      className: this.props.className,
      ref: this.selectRef,
      styles: this.props.styles,
      menuPortalTarget: this.props.menuPortalTarget,
      defaultInputValue: this.props.defaultInputValue,
      isClearable: this.props.isClearable,
      isSearchable: this.props.isSearchable,
      menuIsOpen: menuIsOpen || undefined,
      menuPlacement: this.props.menuPlacement,
      placeholder: this.props.placeholder,
      onBlur: this.props.onBlur,
      loadingMessage: () => <span>{this.props.t('common:search_in_progress')} <i className="fas fa-spin fa-spinner ml-2" /></span>,
      noOptionsMessage: this.props.noOptionsMessage,
      loadOptions: this.fetchData,
      defaultOptions: true,
      onInputChange: this.handleInputChange,
      onChange: (selected) => {
        if (isMulti) {
          if (!selected) {
            this.setState({ value: [] });
            this.props.onChange([]);
            return;
          }
          this.setState({ value: selected });
          this.props.onChange(selected);
          return;
        }

        if (isNull(selected)) {
          this.setState({ value: null });
          this.props.onChange(null);
        } else if (isNull(selected.value)) {
          this.setState({
            value: null,
            searchNotFound: this.state.search,
            modalAdd: true,
          });
        } else {
          if(selected?.__isNew__){
            this.setState({
              value: {
                value: selected.value,
                label: selected.value,
              }
            });
            this.props.onChange(selected.value);
          } else {
            const entity = data.find(e => e.id === selected.value);
            this.setState({
              value: {
                value: entity.id,
                label: this.getLabelSelected(entity),
              }
            });

            this.props.onChange(entity);
          }
        }
      },
      value: value,
      isMulti
    }

    let SelectComponent = AsyncSelect;
    if(this.props.isCreateable) {
      SelectComponent = AsyncCreatableSelect;

      selectProps.createOptionPosition = 'last';
      selectProps.formatCreateLabel = (value) => value;
    }

    return <React.Fragment>
      <SelectComponent
        {...selectProps}
      />
      {this.props.tooltip && <Tooltip id={id} msg={this.props.tooltip} />}
      {modalAdd && <AddModal
        searchText={this.state.searchNotFound}
        form={this.props.addNewForm}
        onModalClose={() => this.setState({modalAdd: false})}
        onAdded={entity => {
          this.setState({
            modalAdd: false,
            value: {
              value: entity.id,
              label: this.getLabelSelected(entity),
            }
          });
          this.props.onChange(entity);
        }}
      />}
    </React.Fragment>
  }
}

ApplicationSelect.defaultProps = {
  className: '',
  menuPlacement: 'bottom',
  placeholder: 'Wybierz',
  menuIsOpen: false,
  sortField: 'id',
  sortOrder: 'desc',
  addNewOption: null,
  addNewForm: null,
  isCreateable: false,
  isSearchable: true,
  isClearable: true,
  noOptionsMessage: () => <span>Nic nie znaleziono</span>,
  isMulti: false,
};

ApplicationSelect.propTypes = {
  tooltip: PropTypes.string,
  menuPlacement: PropTypes.string,
  menuPortalTarget: PropTypes.any,
  styles: PropTypes.object,
  isCreateable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  label: PropTypes.object,
  labelSelected: PropTypes.object,
  sortField: PropTypes.string,
  sortOrder: PropTypes.string,
  menuIsOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  defaultInputValue: PropTypes.string,
  value: PropTypes.number,
  inputValue: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  fetchById: PropTypes.func.isRequired,
  searchData: PropTypes.func.isRequired,
  addNewOption: PropTypes.object,
  addNewForm: PropTypes.func,
  noOptionsMessage: PropTypes.func,
  isMulti: PropTypes.bool,
};

export default withTranslation()(ApplicationSelect);
